module.exports = __webpack_public_path__ + "static/media/empty.8d174045.svg";